import { Box, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import Card from "../../components/common/Card";

const AdminDetail = () => {
  const { t } = useTranslation();
  return (
    <Card>
      <Box>
        <InfoRow>
          <Title>{t("admin_user.add_modal.email")}:</Title>
          <Value>Admin admin</Value>
        </InfoRow>
      </Box>
    </Card>
  );
};

export default AdminDetail;

const InfoRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  margin: `0 0 ${theme.spacing(2)} 0`,
}));
const Title = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));
const Value = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  fontWeight: "normal",
}));
